import React from "react";
import FocusBackground from "./components/FocusBackground";
import NavBar from "./components/NavBar";
import Landing from "./sections/Landing";
import Projects from "./sections/Projects";
import Education from "./sections/Education";
import Contact from "./sections/Contact";
import './styles/global.css';
import useScrollRestoration from "./hooks/useScrollRestoration";
import usePageTitle from "./hooks/usePageTitle";
import useSectionScrollSnap from "./hooks/useSectionScrollSnap";


function App(){
    useScrollRestoration(); // default key
    usePageTitle(); // default title
    useSectionScrollSnap(); // one section per wheel gesture, without fighting momentum scroll

  return (
    <div>
      <FocusBackground/>
      <NavBar/>
      <Landing/>
      <Projects/>
      <Education/>
      <Contact/>
    </div>
  )
}


export default App;
